import React from 'react'
import style from '../style.module.less'

export default store => [
  {
    title: '婚宴菜单',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    render: (text, { name }) => (
      <div className={style.sit_ting}>
        <span>{name}</span>
      </div>
    )
  },
  {
    title: <p style={{ textAlign: 'center' }}>向上</p>,
    key: 'name2',
    width: 100,
    className: 'hlj-text-center' /*`${style['tab-center']}`*/,
    render: (name2, { id }, index) => {
      if (index == 0) {
        return (
          <div>
            <div>
              <img src="//qnm.hunliji.com/o_1b4kp7knc1gj2nft1r0q1ut51tgdc.png" />
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <div>
              <a onClick={store.upnum(id)}>
                <img src="//qnm.hunliji.com/o_1b4kp7kncuda1idr2cl1u581kv8f.png" />
              </a>
            </div>
          </div>
        )
      }
    }
  },
  {
    title: <p style={{ textAlign: 'center' }}>向下</p>,
    key: 'name3',
    width: 100,
    className: 'hlj-text-center',
    render: (name3, { id }, index) => {
      if (index == store.total_count - 1) {
        return (
          <div>
            <div>
              <img src="//qnm.hunliji.com/o_1b4kp7knc1g98ser1agssh19ukg.png" />
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <div>
              <a onClick={store.downnum(id)}>
                <img src="//qnm.hunliji.com/o_1b4kp7knc1lpgeh81c0ej5qpo0d.png" />
              </a>
            </div>
          </div>
        )
      }
    }
  },
  {
    title: <p style={{ textAlign: 'center' }}>置顶</p>,
    key: 'name4',
    width: 100,
    className: 'hlj-text-center',
    render: (name4, { id }, index) => {
      if (index == 0) {
        return (
          <div>
            <div>
              <img src="//qnm.hunliji.com/o_1b4kp7knc3q8b09h9o1nc81lkie.png" />
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <div>
              <a onClick={store.totop(id)}>
                <img src="//qnm.hunliji.com/o_1b4kp7knc1o667mj1atq1bsstbkh.png" />
              </a>
            </div>
          </div>
        )
      }
    }
  }
]
